<template>
    <div class="popwrap modulewrap">

    </div>
</template>

<script>
    export default {
        name: 'pop',
        props: {
            popurl: {
                type: String,
                default: ''
            },
            poptype: {
                type: Number,
                default: 1
            }
        },
        methods: {
            updatepoptype: function (v) {
                this.$emit('update:poptype', v);
            }
        }
    };
</script>
